export const SET_CATEGORY_SELECTED_ID = "SET_CATEGORY_SELECTED_ID";
export const SET_CATEGORIES = "SET_CATEGORIES"; 